import edition2017 from './2017.json' assert {type: 'json'}
import edition2022 from './2022.json' assert {type: 'json'}

export default {
	2017: edition2017,
	2022: edition2022,
}
